import { ListViewRowWrapper } from '@ami/react/core';
import PropTypes from 'prop-types';
import { Quote } from '../../../quotes/quote';
import Row from './InventoryItemTableRow';
import { QuoteInventoryItemViewModel } from './QuoteInventoryItemViewModel';

const InventoryItemTable = ({
  products,
  productGroups,
  inventoryItems,
  onProductSelected,
  productId,
  inventoryItemId,
  onOpenEdit,
  viewAllProducts,
  selectedInventoryItem,
  canSelectInventoryItem,
  quote,
  isOrderFormMode,
  highlightedInventoryItemId,
  highlightedInventoryItem
}) => {
  if (highlightedInventoryItemId) {
    const firstFilters = [highlightedInventoryItemId];
    inventoryItems.sort((x, y) => (+firstFilters.includes(y.id) - +firstFilters.includes(x.id)) || x.name.localeCompare(y.name));
  } else {
    inventoryItems.sort((x, y) => x.name.localeCompare(y.name));
  }

  if (selectedInventoryItem?.id && !inventoryItems.some(x => x.id === selectedInventoryItem.id)) {
    let clonedInventoryItem = new QuoteInventoryItemViewModel(selectedInventoryItem);
    clonedInventoryItem.incompatible = true;
    inventoryItems.unshift(clonedInventoryItem);
  }

  if (highlightedInventoryItem?.id && !inventoryItems.some(x => x.id === highlightedInventoryItem.id)) {
    let clonedHighlightedInventoryItem = new QuoteInventoryItemViewModel(highlightedInventoryItem);
    clonedHighlightedInventoryItem.incompatible = true;
    inventoryItems.unshift(clonedHighlightedInventoryItem);
  }

  const inQuoteInventoryItemIds = quote.products.map(x => x.inventoryItemId) || [];

  const rows = (inventoryItems || []).filter(x => x).map((inventoryItem) => {
    const product = products.find(x => x.id === inventoryItem.productId);
    const productGroup = productGroups.find(x => x.id === inventoryItem.productGroupId);

    if (inQuoteInventoryItemIds.includes(inventoryItem.id)) {
      inventoryItem.isAddedToQuote = true;
    }

    return (
      <Row
        inventoryItem={inventoryItem}
        product={product}
        productGroup={productGroup}
        key={inventoryItem.id}
        onProductSelected={onProductSelected}
        productId={productId}
        inventoryItemId={inventoryItemId}
        onOpenEdit={onOpenEdit}
        canSelectInventoryItem={canSelectInventoryItem}
        highlightedInventoryItemId={highlightedInventoryItemId}
      />
    )
  });
  return (
    <div className="row">
      <div className="col-12">
        <table className={isOrderFormMode ? "table" : "table table-hover table-striped table-mobile"}>
          <thead>
            <tr>
              <th width="40%" colSpan={2}>Item</th>
              <th width="10%">Condition</th>
              <th width="28%">Compatibility</th>
              <th width="10%">Availability</th>
              <th width="12%"></th>
            </tr>
          </thead>
          <tbody>
            <ListViewRowWrapper
              rows={rows}
              numberOfColumns={7}
            />
          </tbody>
        </table>
      </div>

      <div className="col-12">
        <div className="alert alert-warning">
          Didn't find what you're looking for?
          <span>
            <button type="button" className="btn btn-link ms-1" onClick={() => viewAllProducts()}>View All Products</button>
          </span>
        </div>
      </div>
    </div>
  );
};

InventoryItemTable.propTypes = {
  products: PropTypes.arrayOf(Object),
  productGroups: PropTypes.arrayOf(Object),
  inventoryItems: PropTypes.arrayOf(PropTypes.instanceOf(QuoteInventoryItemViewModel)).isRequired,
  onProductSelected: PropTypes.func.isRequired,
  productId: PropTypes.string,
  inventoryItemId: PropTypes.string,
  onOpenEdit: PropTypes.func.isRequired,
  viewAllProducts: PropTypes.func.isRequired,
  selectedInventoryItem: PropTypes.instanceOf(QuoteInventoryItemViewModel),
  canSelectInventoryItem: PropTypes.bool.isRequired,
  quote: PropTypes.instanceOf(Quote).isRequired,
  isEditProductMode: PropTypes.bool.isRequired,
  isOrderFormMode: PropTypes.bool.isRequired,
  highlightedInventoryItemId: PropTypes.string,
  highlightedInventoryItem: PropTypes.instanceOf(QuoteInventoryItemViewModel),
};

export { InventoryItemTable };
